/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _join = _interopRequireDefault(require("../../../common/join"));
var _props2flex = _interopRequireDefault(require("./props2flex"));
var _prefix = _interopRequireDefault(require("./prefix"));
var PREFIX = _prefix.default;
var _default = function _default(props) {
  var column = !!props.column;
  var row = !column && !!props.row;
  var reverse = props.reverse ? '-reverse' : '';
  var flex = (0, _props2flex.default)(props);
  var flexGrow = props.flexGrow;
  var flexShrink = props.flexShrink;
  var flexBasis = props.flexBasis;
  var display = props.inline ? 'inline-flex' : props.display;
  var className = (0, _join.default)(props.className, props.alignItems ? "".concat(PREFIX, "--align-items-").concat(props.alignItems) : null, props.alignContent ? "".concat(PREFIX, "--align-content-").concat(props.alignContent) : null, props.justifyContent ? "".concat(PREFIX, "--justify-content-").concat(props.justifyContent) : null, props.wrap ? "".concat(PREFIX, "--wrap") : null, props.alignSelf ? "".concat(PREFIX, "--align-self-").concat(props.alignSelf) : null, row ? "".concat(PREFIX, "--row").concat(reverse) : null, column ? "".concat(PREFIX, "--column").concat(reverse) : null, flex != null ? "".concat(PREFIX, "--flex-").concat(flex) : null, flexGrow != null ? "".concat(PREFIX, "--flex-grow-").concat(flexGrow) : null, flexShrink != null ? "".concat(PREFIX, "--flex-shrink-").concat(flexShrink) : null, flexBasis != null ? "".concat(PREFIX, "--flex-basis-").concat(flexBasis) : null, display != null ? "".concat(PREFIX, "--display-").concat(display) : null);
  return className;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Flex/src/props2className.js
// module id = 244
// module chunks = 0